import http from "./httpService";
import config from "./../config.json";
import { getBase64 } from "./../utils/stringUtils";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "compliances";

export const saveComplianceStatusAsync = async (id, data) => {
  const files = [];

  if (typeof data.files !== "undefined")
    for (let i = 0; i < data.files.length; i++) {
      const file = await getBase64(data.files[i]);
      const content = file.split(",")[1];
      files.push({
        file_name: data.files[i].name,
        content,
      });
    }

  const compliance = { ...data };
  compliance["files"] = files;
  compliance["status"] = data.status.value;

  if (data.status.value === "1") {
    compliance["document_updated"] = data.date;
  } else {
    compliance["due_date"] = data.date;
  }

  return await http.post(`${apiEndpoint}/statuses/${id}`, compliance);
};

export const saveAccountCompliancesAsync = async (id, data) => {
  const compliances = data.map((item) => {
    const compliance = {};
    compliance["product_id"] = item.id;
    compliance["is_active"] = item.is_compliance_active;

    return compliance;
  });

  return await http.post(`${apiEndpoint}/${id}`, compliances);
};

export const saveCORAsync = async (info) => {
  const files = [];

  if (typeof info.files !== "undefined") {
    for (let i = 0; i < info.files.length; i++) {
      const file = await getBase64(info.files[i]);
      const content = file.split(",")[1];
      files.push({
        file_name: info.files[i].name,
        content,
      });
    }
  }

  const cor = { ...info };
  cor["files"] = files;

  if (cor.id) {
    const { data } = await http.put(
      `${apiEndpoint}/certificate-of-registrations`,
      cor
    );
    return data.result;
  }

  const { data } = await http.post(
    `${apiEndpoint}/certificate-of-registrations`,
    cor
  );

  return data.result;
};

export const saveCORDeadlineAsync = async (info) => {
  const url = `${apiEndpoint}/certificate-of-registrations/deadlines`;
  const { data } = await http.put(url, info);
  return data.result;
};

export const saveCORItemAsync = async (info) => {
  const files = [];

  if (typeof info.files !== "undefined") {
    for (let i = 0; i < info.files.length; i++) {
      const file = await getBase64(info.files[i]);
      const content = file.split(",")[1];
      files.push({
        file_name: info.files[i].name,
        content,
      });
    }
  }

  const cor_item = { ...info };
  cor_item["files"] = files;

  const url = `${apiEndpoint}/certificate-of-registrations/items`;

  if (cor_item.certificate_of_registration_item_id) {
    const { data } = await http.put(url, cor_item);
    return data.result;
  }

  const { data } = await http.post(url, cor_item);
  return data.result;
};

export const cancelCORAsync = async (info) => {
  return await http.put(
    `${apiEndpoint}/certificate-of-registrations/cancel`,
    info
  );
};

export const saveCORFormsAsync = async (items) => {
  const { data } = await http.post(
    `${apiEndpoint}/certificate-of-registrations/forms`,
    items
  );

  return data.result;
};

export const saveS2LicenseAsync = async (info) => {
  const files = [];

  if (typeof info.files !== "undefined") {
    for (let i = 0; i < info.files.length; i++) {
      const file = await getBase64(info.files[i]);
      const content = file.split(",")[1];
      files.push({
        file_name: info.files[i].name,
        content,
      });
    }
  }

  const item = { ...info };
  item["files"] = files;

  if (item.id) {
    const { data } = await http.put(`${apiEndpoint}/s2-licenses`, item);
    return data.result;
  }

  const { data } = await http.post(`${apiEndpoint}/s2-licenses`, item);
  return data.result;
};

export const savePTRAsync = async (info) => {
  const files = [];

  if (typeof info.files !== "undefined") {
    for (let i = 0; i < info.files.length; i++) {
      const file = await getBase64(info.files[i]);
      const content = file.split(",")[1];
      files.push({
        file_name: info.files[i].name,
        content,
      });
    }
  }

  const item = { ...info };
  item["files"] = files;

  if (item.id) {
    const { data } = await http.put(
      `${apiEndpoint}/professional-tax-receipts`,
      item
    );
    return data.result;
  }

  const { data } = await http.post(
    `${apiEndpoint}/professional-tax-receipts`,
    item
  );
  return data.result;
};

export const saveSwornDeclarationAsync = async (info) => {
  const files = [];

  if (typeof info.files !== "undefined") {
    for (let i = 0; i < info.files.length; i++) {
      const file = await getBase64(info.files[i]);
      const content = file.split(",")[1];
      files.push({
        file_name: info.files[i].name,
        content,
      });
    }
  }

  const item = { ...info };
  item["files"] = files;

  if (item.id) {
    const { data } = await http.put(`${apiEndpoint}/sworn-declarations`, item);
    return data.result;
  }

  const { data } = await http.post(`${apiEndpoint}/sworn-declarations`, item);
  return data.result;
};

export const generateCORDeadlinesAsync = async (id) => {
  const url = `${apiEndpoint}/certificate-of-registrations/deadlines/${id}`;
  return await http.post(url);
};

export const deleteCORFormAsync = async (id) => {
  return await http.delete(
    `${apiEndpoint}/certificate-of-registrations/forms/${id}`
  );
};

export const deleteCORDeadlineAsync = async (id) => {
  const url = `${apiEndpoint}/certificate-of-registrations/deadlines/${id}`;
  return await http.delete(url);
};

export const deleteS2LicenseAsync = async (id) => {
  return await http.delete(`${apiEndpoint}/s2-licenses/${id}`);
};

export const deletePTRAsync = async (id) => {
  return await http.delete(`${apiEndpoint}/professional-tax-receipts/${id}`);
};

export const deleteSwornDeclarationAsync = async (id) => {
  return await http.delete(`${apiEndpoint}/sworn-declarations/${id}`);
};

export const getAccountCompliancesAsync = async (id) => {
  const { data } = await http.get(`${apiEndpoint}/${id}`);
  return data;
};

export const getCORInfoAsync = async (id) => {
  const url = `${apiEndpoint}/certificate-of-registrations/${id}`;
  const { data } = await http.get(url);
  return data.result;
};

export const getCORDeadlineItemsAsync = async (id, year) => {
  const url = `${apiEndpoint}/certificate-of-registrations/deadlines/${id}?year=${year}`;
  const { data } = await http.get(url);
  return data.result;
};

export const getCORDeadlinesAsync = async (params) => {
  const {
    year,
    sort_column,
    size,
    search_query: query,
    current_page: page,
  } = params;

  const tax_type =
    params.tax_type && params.tax_type !== undefined
      ? params.tax_type.label
      : "";

  const status =
    params.status && params.status !== undefined ? params.status.value : "";

  let period = "";
  let period_type = "";

  if (params.period && params.period !== undefined) {
    period = params.period.value.period;
    period_type = params.period.value.period_type;
  }

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/certificate-of-registrations/deadlines?q=${query}&tax-type=${tax_type}&year=${year}&period=${period}&period-type=${period_type}&status=${status}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getCORsAsync = async (params) => {
  const {
    sort_column,
    status,
    cor,
    rdo,
    search_query: query,
    start_date: from,
    end_date: to,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/certificate-of-registrations?q=${query}&status=${status}&rdo=${rdo}&cor=${cor}&from=${from}&to=${to}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountCORsAsync = async (id, params) => {
  const {
    sort_column,
    status,
    search_query: query,
    start_date: from,
    end_date: to,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/certificate-of-registrations/accounts/${id}?q=${query}&status=${status}&from=${from}&to=${to}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountS2LicensesAsync = async (id, params) => {
  const {
    sort_column,
    search_query: query,
    start_date: from,
    end_date: to,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/s2-licenses/${id}?q=${query}&from=${from}&to=${to}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountPTRsAsync = async (id, params) => {
  const {
    sort_column,
    search_query: query,
    start_date: from,
    end_date: to,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/professional-tax-receipts/${id}?q=${query}&from=${from}&to=${to}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountSwornDeclarationsAsync = async (id, params) => {
  const {
    sort_column,
    year,
    search_query: query,
    start_date: from,
    end_date: to,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/sworn-declarations/${id}?q=${query}&year=${year}&from=${from}&to=${to}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getCORFormsAsync = async (id) => {
  const { data } = await http.get(
    `${apiEndpoint}/certificate-of-registrations/forms/${id}`
  );

  return data.result;
};

export const getTaxTypesAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/tax-types`);
  return data.result;
};

export const getTaxTypeFormsAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/tax-types/forms`);
  return data.result;
};

export const getCORStatuses = () => {
  return [
    { value: 0, label: "Inactive" },
    { value: 1, label: "Active" },
  ];
};

export const getCORShowOptions = () => {
  return [
    { label: "All", value: "" },
    { label: "With COR", value: true },
    { label: "Without COR", value: false },
  ];
};

export const getCORDeadlineStatusProperties = (status) => {
  let properties = {};

  switch (status) {
    case 1:
      properties = { bg_color: "bg-gray-400" };
      break;
    case 2:
      properties = { bg_color: "bg-green-400" };
      break;
    case 3:
      properties = { bg_color: "bg-yellow-400" };
      break;
    case 4:
      properties = { bg_color: "bg-red-400" };
      break;
    default:
      properties = { bg_color: "bg-gray-400" };
  }

  return properties;
};

export const getCORDeadlineStatuses = () => {
  return [
    { value: 1, label: "Unfiled" },
    { value: 2, label: "Filed" },
    { value: 3, label: "Upcoming" },
    { value: 4, label: "To Upload" },
  ];
};

export const getCORDeadlinePeriods = () => {
  return [
    { value: { period_type: 1, period: 1 }, label: "Annual" },
    { value: { period_type: 2, period: 1 }, label: "1st Quarter" },
    { value: { period_type: 2, period: 2 }, label: "2nd Quarter" },
    { value: { period_type: 2, period: 3 }, label: "3rd Quarter" },
    { value: { period_type: 2, period: 4 }, label: "4th Quarter" },
    { value: { period_type: 3, period: 1 }, label: "January" },
    { value: { period_type: 3, period: 2 }, label: "February" },
    { value: { period_type: 3, period: 3 }, label: "March" },
    { value: { period_type: 3, period: 4 }, label: "April" },
    { value: { period_type: 3, period: 5 }, label: "May" },
    { value: { period_type: 3, period: 6 }, label: "June" },
    { value: { period_type: 3, period: 7 }, label: "July" },
    { value: { period_type: 3, period: 8 }, label: "August" },
    { value: { period_type: 3, period: 9 }, label: "September" },
    { value: { period_type: 3, period: 10 }, label: "October" },
    { value: { period_type: 3, period: 11 }, label: "November" },
    { value: { period_type: 3, period: 12 }, label: "December" },
  ];
};

export const getComplianceStatuses = () => {
  return [
    { value: 1, label: "Updated" },
    { value: 2, label: "Due" },
    { value: 3, label: "Overdue" },
  ];
};

const complianceService = {
  saveComplianceStatusAsync,
  saveAccountCompliancesAsync,
  saveCORAsync,
  saveCORDeadlineAsync,
  saveCORItemAsync,
  saveCORFormsAsync,
  saveS2LicenseAsync,
  savePTRAsync,
  saveSwornDeclarationAsync,
  cancelCORAsync,
  generateCORDeadlinesAsync,
  deleteCORFormAsync,
  deleteCORDeadlineAsync,
  deleteS2LicenseAsync,
  deletePTRAsync,
  deleteSwornDeclarationAsync,
  getAccountCompliancesAsync,
  getCORsAsync,
  getCORInfoAsync,
  getCORDeadlineItemsAsync,
  getCORDeadlinesAsync,
  getAccountCORsAsync,
  getAccountS2LicensesAsync,
  getAccountPTRsAsync,
  getAccountSwornDeclarationsAsync,
  getCORFormsAsync,
  getTaxTypesAsync,
  getTaxTypeFormsAsync,
  getCORStatuses,
  getCORShowOptions,
  getCORDeadlineStatusProperties,
  getCORDeadlineStatuses,
  getCORDeadlinePeriods,
  getComplianceStatuses,
};

export default complianceService;
